import { render } from "./FormInfoRow.vue?vue&type=template&id=5da858d6&scoped=true"
import script from "./FormInfoRow.vue?vue&type=script&lang=js"
export * from "./FormInfoRow.vue?vue&type=script&lang=js"

import "./FormInfoRow.vue?vue&type=style&index=0&id=5da858d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da858d6"]])

export default __exports__